<script setup>
import { ref, watch } from "vue";
import { defineAsyncComponent } from "vue";

// PrimeVue Dialog
const Dialog = defineAsyncComponent(() => import("primevue/dialog"));

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: true,
  },
});
const emit = defineEmits(["close", "CloseAndPaymentOpen"]);
const visible = ref(props.isOpen);

watch(
  () => props.isOpen,
  (newVal) => {
    visible.value = newVal;
  }
);

watch(visible, (newVal) => {
  if (!newVal) {
    emit("close");
  }
});

const handleClose = () => {
  visible.value = false;
};
</script>

<template>
  <div class="card flex justify-center z-30">
    <Dialog
      aria-label="Coming Soon"
      v-model:visible="visible"
      :modal="true"
      :dismissableMask="true"
      closeOnEscape
      closable
      unstyled
      class="w-[90vw] lg:w-[45vw] lg:max-h-[70vh] h-full max-sm:max-h-[70vh] max-h-[80vh]"
      :pt="{
        root: {
          class:
            'relative bg-[linear-gradient(180deg,_#b8cafc,_#b8e0fc_30%,_#b8e0fc)] shadow-[0_0.3em_0.3em_-0.3em_hsla(0,0%,4%,0.1),0_0_0_0.1rem_hsla(0,0%,4%,0.08)] max-w-full rounded-xl no-scrollbar',
        },
        headerActions: {
          class: 'hidden',
        },
        mask: {
          class: 'bg-[hsla(0,_0%,_4%,_0.7)]',
        },
      }"
    >
      <template #header>
        <div class="absolute -top-3 -right-3 z-40">
          <button @click="handleClose">
            <WrSVGIcon
              name="WrCrossIcon"
              class="text-white p-1 bg-[#5f4ca4] rounded-full border-2 size-[30px]"
            />
          </button>
        </div>
      </template>
      <div class="m-auto text-center px-10 py-8">
        <NuxtImg
          src="/images/details-coming-soon.webp"
          height="317"
          width="512"
          alt="Coming Soon Image"
          loading="lazy"
          class="h-auto mx-auto"
          format="webp"
        />
        <div
          class="text-[45px] leading-[1em] mb-[15px] text-[#e2f0fa] font-[Kanit] w-full [text-shadow:0_1px_0_#91adfa,0_2px_0_#87a5fa,0_3px_0_#7d9efa,0_4px_0_#7397f9,0_5px_0_#6a90f9,0_6px_0_#6088f8,0_7px_0_#5681f8,0_8px_0_#4c7af7,0_0_5px_rgba(130,163,255,0.05),0_-1px_3px_rgba(130,163,255,0.2),0_9px_9px_rgba(130,163,255,0.3),0_12px_12px_rgba(130,163,255,0.3),0_15px_15px_rgba(130,163,255,0.3)] font-bold"
        >
          COME BACK SOON
        </div>
        <div
          class="text-xl text-[#537ff7] leading-[1.125] font-semibold break-words"
        >
          We're updating our website's content.
        </div>
      </div>
    </Dialog>
  </div>
</template>
